import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { TableCell, TableRow } from "@/components/ui/table";
import { type Row, flexRender } from "@tanstack/react-table";
import { MoreHorizontal } from "lucide-react";
import React from "react";

export type DropdownItem<TData> = {
  label: string;
  onClick: (rowData: TData) => void;
};

type DataRowProps<TData> = {
  row: Row<TData>;
  dropdownItems: DropdownItem<TData>[];
};

export function DataRow<TData>({ row, dropdownItems }: DataRowProps<TData>) {
  return (
    <TableRow>
      {row.getVisibleCells().map((cell) => (
        <TableCell key={cell.id}>
          {flexRender(cell.column.columnDef.cell, cell.getContext())}
        </TableCell>
      ))}
      <TableCell>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button aria-haspopup="true" size="icon" variant="ghost">
              <MoreHorizontal className="h-4 w-4" />
              <span className="sr-only">Toggle menu</span>
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuLabel>Actions</DropdownMenuLabel>
            {dropdownItems.map((item, index) => (
              <DropdownMenuItem
                key={index}
                onClick={() => item.onClick(row.original)}
              >
                {item.label}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      </TableCell>
    </TableRow>
  );
}
